<template>
  <div>
    <!-- 分配 -->
    <el-dialog :title="dialogVisibleTitle" :close-on-click-modal="false" :visible.sync="dialogVisible" width="300px"
      center>
      <div class="allot">
        <el-select v-model="allotVal" class="item" filterable>
          <el-option v-for="item in allotOptions" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="primary" @click="allotSave">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    selectList: { type: Array },
    personnelData: { type: Object },
  },
  data() {
    return {
      //   批量分配
      dialogVisible: false,
      dialogVisibleTitle: "",
      allotVal: "",
      allotOptions: [],
    };
  },
  computed: {
    y() {
      return this.personnelData.y;
    },
    g() {
      return this.personnelData.g;
    },
    p() {
      return this.personnelData.p;
    },
  },
  methods: {
    //显示分配弹框
    allot(type) {
      this.allotType = type;
      if (type == "y") {
        this.allotOptions = this.y;
        this.dialogVisibleTitle = this.$t("message.adjustBusiness");
      } else if (type == "p") {
        this.allotOptions = this.p;
        this.dialogVisibleTitle = this.$t("message.distribution");
      } else if (type == "g") {
        this.dialogVisibleTitle = this.$t("message.adjustPurchase");
        this.allotOptions = this.g;
      }
      this.allotVal = "";
      this.dialogVisible = true;
    },
    // 分配
    allotSave() {
      let datas = {
        user_id: [],

      };
      this.selectList.forEach((item) => {
        datas.user_id.push(item.id)
      });
      if (this.allotType == "y") {
        datas.y_id = this.allotVal;
      } else if (this.allotType == "p") {
        datas.p_id = this.allotVal;
      } else if (this.allotType == "g") {
        datas.g_id = this.allotVal;
      }

      this.$api.clienteleApi.setClientAdmins(datas).then((res) => {
        this.$parent.clientList();
        this.$parent.selectList = [];
        this.dialogVisible = false;
      });

    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-select {
  width: 100%;
}
</style>